// Central asset registry. Product data is structured e-commerce-ready
// (price, currency, specs, images) so a Shopify/Stripe layer can bolt on later.

export const IMAGES = {
  logo: "/logos/rayceparts_logo.png",
  symbol: "/logos/rp_symbol.png",
  heroPod:
    "https://static.prod-images.emergentagent.com/jobs/da5367fd-7145-4298-8fa9-1016d7aac3b9/images/6b974940976f2949913381d1c4d4997033f6b53d8d1a97b112f73b83f44c426c.jpeg",
  gaugePodPhoto:
    "https://static.prod-images.emergentagent.com/jobs/da5367fd-7145-4298-8fa9-1016d7aac3b9/images/af5bd803492537113fb4ae20d4dc004f07189647417a64a3771aac770fa4d937.jpeg",
  gaugePodWire:
    "https://static.prod-images.emergentagent.com/jobs/da5367fd-7145-4298-8fa9-1016d7aac3b9/images/d68a63669c32319f72273266abd9b27a07d2e1e240cb49782f2af6c57a975434.jpeg",
  cupholderPhoto:
    "https://static.prod-images.emergentagent.com/jobs/da5367fd-7145-4298-8fa9-1016d7aac3b9/images/ea52ca0275ca1c3da3306f81960977b8d3182ca2efd68bf468621ca26b7c3234.jpeg",
  cupholderWire:
    "https://static.prod-images.emergentagent.com/jobs/da5367fd-7145-4298-8fa9-1016d7aac3b9/images/1c7063ce861b9b0323dcd94d4b96ff0f032bdb4d7537e80061f25d3b26d32a0f.jpeg",
};

export const PROCESS = [
  {
    n: "01",
    title: "CAD Design",
    body: "Every part starts as a precision CAD model, mapped to factory mounting points for a genuine OEM-grade fit — never a guessed universal shape.",
    img: "https://images.pexels.com/photos/3861938/pexels-photo-3861938.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    n: "02",
    title: "3D Print",
    body: "Printed in durable, heat-aware material with a clean matte finish that sits right at home inside a JDM interior — built to last on the street and the track.",
    img: "https://images.pexels.com/photos/23533982/pexels-photo-23533982.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    n: "03",
    title: "Fitted in Car",
    body: "Test-fitted and dialled in on a real chassis. What ships to you is what already sat clean in the console — no trimming, no bodging, no bad kits.",
    img: "https://images.pexels.com/photos/13237631/pexels-photo-13237631.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const INSTAGRAM = [
  IMAGES.gaugePodPhoto,
  "https://images.unsplash.com/photo-1611953070713-6e5fb4b97b66?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  IMAGES.cupholderPhoto,
  IMAGES.gaugePodWire,
  "https://images.pexels.com/photos/28293569/pexels-photo-28293569.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/9098526/pexels-photo-9098526.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const INSTAGRAM_URL = "https://instagram.com/rayce_parts";
